import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/** Ícono de código de barras (no QR). */
export default function BarcodeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M2 5h1.5v14H2V5zm2.5 0H6v14H4.5V5zM7 5h1v14H7V5zm2 0h2.5v14H9V5zm3.5 0h1v14h-1V5zm2 0h2v14h-2V5zm3 0h1v14h-1V5zm2 0H22v14h-2.5V5z" />
    </SvgIcon>
  );
}
